




import Vue from "vue";
import { Component } from "vue-property-decorator";
import { deleteToken, tokenValid } from "../../services/AuthService";

@Component({})
export default class Home extends Vue {
  constructor() {
    super();
  }

  beforeCreate() {
    const isTokenValid = tokenValid(null);
    if (!isTokenValid) {
      console.log("Token not valid");
      deleteToken();
      this.$router.push({ path: "/login" });
    } else {
      this.$router.push({ path: "/shipments" });
    }
  }
}
